import en from './en.json'
import hi from './hi.json'
import kn from './kn.json'
import mr from './mr.json'
import te from './te.json'

export const locale = {
 en,
 hi,
 kn,
 mr,
 te,
}

export default locale
